import { Button, Drawer } from "antd-v4";
import { RiCloseFill } from "react-icons/ri";

import MenuLogo from "../logo";
import MenuItem from "../item";
import MenuFooter from "../footer";
import { SignatureFilled } from "@ant-design/icons";
import FeedbackModal from "../../../../view/pages/conversations/components/FeedbackModal";
import { useState } from "react";

export default function MenuMobile(props) {
  const { onClose, visible } = props;

  const [displayFeedbackForm, setDisplayFeedbackForm] = useState(false);

  return (
    <Drawer
      title={<MenuLogo onClose={onClose} />}
      width={256}
      className="hp-mobile-sidebar hp-sidebar"
      placement="left"
      closable={true}
      onClose={onClose}
      open={visible}
      closeIcon={
        <RiCloseFill className="remix-icon hp-text-color-black-80" size={24} />
      }
    >
      <MenuItem onClose={onClose} />

      <Button
        icon={<SignatureFilled className="hp-mr-6" />}
        type="text"
        style={{ backgroundColor: 'white', color: '#6737ff' }}
        onClick={() => { setDisplayFeedbackForm(true) }}
      >
        Nous contacter
      </Button>

      <MenuFooter onClose={onClose} collapsed={false} />
      <FeedbackModal
        title={'J\'ai besoin d\'aide'}
        visible={displayFeedbackForm}
        onOk={() => setDisplayFeedbackForm(false)}
        onCancel={() => setDisplayFeedbackForm(false)} />
    </Drawer>
  );
}
